import * as React from 'react'
import { Link, Route, RouteComponentProps } from 'react-router-dom'
import Plus from '../icons/organizations/Plus'
import BackToList from '../ui/BackToList'
import AddMobilityCategoryModal from './AddMobilityCategoryModal'
import EditMoblityCategoryModal from './EditMoblityCategoryModal'
import RemoveMobilityCategoryModal from './RemoveMobilityCategoryModal'
import SettingList from './SettingList'

export default class MobilityCategoryPane extends React.Component<RouteComponentProps<any>> {
  public render() {
    return (
      <React.Fragment>
        <Route path={`${this.props.match.path}/create`} component={AddMobilityCategoryModal} />
        <Route path={`${this.props.match.path}/remove/:id`} component={RemoveMobilityCategoryModal} />
        <Route path={`${this.props.match.path}/edit/:id`} component={EditMoblityCategoryModal} />
        <BackToList link='/global-settings' className='flex' />
        <div className='pt3'>
          <div className='flex justify-between mb2'>
            <div className='pl3 h3 bold font-blue-grey'>Mobility Category</div>
            <Link
              className='btn bg-green rounded font-white mr2 flex justify-center items-center'
              to='/global-settings/mobility-category/create'
            >
              <Plus className='svg-white mr1' />
              Add Mobility Category
            </Link>
          </div>
          <hr />
          <div>
            <p className='h5 bold pl2 font-black'>Mobility Category List</p>
            <div className='pl3 pr3 col-4'>
              <SettingList baseUrl={this.props.match.path} settings={[{ label: 'Wheelchair', id: 1 }]} />
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/MobilityCategoryPane.tsx